import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  if (response?.status === 'SUCCESS' && response?.data?.status === 'SUCCESS') {
    return isSuccessResponse(response)
  } else {
    throw {
      message: 'An Unexpected error has occoured',
    }
  }
}

const deleteDevicePlanApi = (id: String, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.deleteDevicePlanApi),
    method: 'POST',
    config: sitConfig(tokens),
    body: deleteDevicePlanRequest(id),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export const deleteDevicePlanRequest = (id: String) => ({ id, status: 'INACTIVE' })

export { deleteDevicePlanApi }
